// @ts-nocheck
import { useLingui, type withI18nProps } from '@lingui/react'
import hoistStatics from 'hoist-non-react-statics'
import { type ComponentType, isValidElement } from 'react'

// https://github.com/lingui/js-lingui/blob/31dcab5a9a8f88bfa8b3a2c7cd12aa2d908a1d80/packages/react/src/I18nProvider.tsx#L33
export function withI18n(
  o?: object
): <P extends withI18nProps>(
  Component: ComponentType<P>
) => ComponentType<Omit<P, 'i18n'>> {
  return <P extends withI18nProps>(
    WrappedComponent: ComponentType<P>
  ): ComponentType<P> => {
    const TargetComponent = props => {
      if (process.env.NODE_ENV !== 'production') {
        if (typeof o === 'function' || isValidElement(o)) {
          throw new Error(
            'withI18n([options]) takes options as a first argument, ' +
              'but received React component itself. Without options, the Component ' +
              'should be wrapped as withI18n()(Component), not withI18n(Component).'
          )
        }
      }

      const { i18n } = useLingui()
      return <WrappedComponent {...props} i18n={i18n} />
    }

    return hoistStatics(TargetComponent, WrappedComponent)
  }
}
